import React from 'react';
import { useSelector } from 'react-redux';
import { Forms, Modal, SaveButton, SystemText } from 'e4shared';
import { apiPatch, apiGet } from 'services';

export const RoleDescriptions = ({ show, close, competency, roles, reload }) => {
    if (!show || !competency) return null;

    const [roleId, setRoleId] = React.useState(null);
    const [description, setDescription] = React.useState('');
    const [positive_Indicators, setPositive_Indicators] = React.useState([]);
    const [saving, setSaving] = React.useState(false);
    const [values, setValues] = React.useState([]);
    const [pis, setPis] = React.useState([]);
    const guid = useSelector(state => state.user.user.guid);
    const availableRoles = roles
        .filter(r => competency.role_Ids.some(x => x === r.id))
        .map(r => ({
            ...r,
            extra: competency.override_Role_Ids.some(x => x === r.id)
                ? () => <i className="fa fa-warning text-warning" />
                : '',
        }));

    const user = useSelector(state => state.user.user);
    const usePIs = user.companySettings?.development?.usePositiveIndicators;

    React.useEffect(() => {
        const match = values.find(x => x.role_Id === roleId);
        setDescription(match ? match.description : '');
        setPositive_Indicators(match ? match.positive_Indicators : []);
    }, [roleId]);

    React.useEffect(() => {
        competency.id && apiGet(`competency-role/${competency.id}`, guid, response => setValues(response));
        competency.id &&
            apiGet(`positive-indicators/${competency.id}`, guid, response =>
                setPis(response.map(p => ({ ...p, name: p.statement })))
            );
    }, [competency.id, guid]);

    React.useEffect(() => {
        if (roleId) {
            let temp = values;
            const match = temp.find(x => x.role_Id === roleId);
            if (match) {
                match.description = description;
                match.positive_Indicators = positive_Indicators;
            } else {
                temp = temp.concat([{ role_Id: roleId, description, positive_Indicators: positive_Indicators }]);
            }
            setValues(temp);
        }
    }, [description, positive_Indicators]);

    const onSave = () => {
        const obj = {
            competency_Id: competency.id,
            details: values,
        };

        apiPatch('competency-role', obj, guid, () => {
            reload?.();
            close?.();
        });
    };

    const systemText = (text, value) => SystemText(`Admin/Competency/Override/${text}`, value);

    const text = {
        title: systemText('Title', competency.name),
        buttons: {
            save: systemText('Buttons/Save'),
            cancel: systemText('Buttons/Cancel'),
        },
        fields: {
            default: {
                label: systemText('Fields/Default/Label'),
            },
            role: {
                label: systemText('Fields/Role/Label'),
                help: systemText('Fields/Role/Help'),
            },
            override: {
                label: systemText('Fields/Override/Label'),
                help: systemText('Fields/Override/Help'),
            },
            positiveIndicators: {
                label: systemText('Fields/PositiveIndicators/Label'),
                help: systemText('Fields/PositiveIndicators/Help'),
            },
        },
    };

    const footer = (
        <div>
            <SaveButton saving={saving} setSaving={setSaving} className="btn btn-success" onClick={onSave}>
                {text.buttons.save}
            </SaveButton>
            <button id="cancel-button" className="btn" onClick={close}>
                {text.buttons.cancel}
            </button>
        </div>
    );

    return (
        <Modal title={text.title} show={show} close={close} footer={footer}>
            <Forms.Label label={text.fields.default.label} value={competency.description} />
            <Forms.Select
                label={text.fields.role.label}
                help={text.fields.role.help}
                data={availableRoles}
                onChange={id => setRoleId(id)}
                value={roleId}
            />
            {roleId && (
                <>
                    <Forms.Textarea
                        label={text.fields.override.label}
                        help={text.fields.override.help}
                        rows="5"
                        value={description}
                        onChange={setDescription}
                    />
                    {usePIs && (
                        <Forms.Select
                            label={text.fields.positiveIndicators.label}
                            help={text.fields.positiveIndicators.help}
                            data={pis}
                            allowMultiple
                            onChange={ids => setPositive_Indicators(ids)}
                            value={positive_Indicators}
                        />
                    )}
                </>
            )}
        </Modal>
    );
};

export default RoleDescriptions;
